/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const teacherMessages: SegmentSpecificMessages = {
  emailExplanation: "Must be your school-issued email address",
  schoolName: "School name",
  schoolNamePlaceholder: "School name",
  step: {
    personalInfo: {
      title: "Unlock this Educator-Only Offer",
      subtitle:
        "Verify you're a educator, faculty, or staff at an accredited educational institution.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer you must currently be employed as a educator faculty or staff at an accredited educational institution." +
        "<br></br>" +
        "{companyName} uses SheerID a trusted partner to verify that you are a current educator faculty or staff member. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & Email",
        subtitle: "Your full name and email address must match what is on record with your school.",
      },
      verifyingTitle: "Verifying your educator status",
      submitButtonText: "Verify My Educator Status",
    },
    docUpload: {
      uploadInstructions: "Upload your school-issued document that shows",
      title: "To continue upload documents that confirm your educator status",
      whoIsSheerId:
        "Document review is handled by SheerID a trusted partner who specializes in verifying educators.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
